<template>
    <el-dialog title="操作" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false"              
               style="margin-top: -50px;">
        <el-form size="small" :model="form">

            <div class="common-form">基本信息</div>
            <el-form-item label="用户id" :label-width="formLabelWidth">
                <el-input v-model="form.user_id" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="昵称" :label-width="formLabelWidth">
                <el-input v-model="form.nickName" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="formLabelWidth">
                <el-input v-model="form.mobile" autocomplete="off" readonly></el-input>
            </el-form-item>

<!--     
            <div class="common-form">供应商操作</div>
            <el-form-item  :label-width="formLabelWidth">
                <Supply :form="form" ></Supply>

            </el-form-item> -->








            
            
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import UserApi from '@/api/user.js';
    import Supply from '@/components/supply/supply_common.vue';
    export default {
        components: {
  
    
        Supply
    },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
        
            };
        },
        props: ['open_add','form'],
        created() {
            this.dialogVisible = this.open_add;
            if(this.form.supply){
               
            }else{
                this.form.supply = {};
            } 
        },
        methods: {
            
    
            editUser(){
                let self = this;
                self.loading = true;
                let params = self.form;
                UserApi.op(params,true)
                    .then(data => {
                        self.loading = false;
                        if (data.code == 1) {
                            self.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            self.dialogFormVisible(true);
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Op.vue